import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
function ProtectedRoute({ children }) {
  const { isAuthenticated } = useSelector((state) => state.user);
  return !isAuthenticated ? children : <Redirect to="/login" />;
}

export default ProtectedRoute;
